<template>
	<div class="bannerContent">
		<div class="swiper-index-banner">
			<div class="swiper-wrapper">
				<div class="swiper-slide" v-for="(item,index) in lista" :key="index" @click="goJump(item)">
					<img :src="item.url" v-if="item.type==1" />
					<template v-else>
						<template v-if="headerShow">
							<video :src="item.url" :autoplay="true" muted loop  :ref="'video'+index" webkit-playsinline playsinline x5-video-player-type="h5-page" :poster="item.url+'?x-oss-process=video/snapshot,t_1000,m_fast'"></video>
						</template>
						<template v-else>
							<video :src="item.url"  muted loop  :ref="'video'+index" webkit-playsinline playsinline x5-video-player-type="h5-page" x5-playsinline="true" controls preload="auto" :poster="item.url+'?x-oss-process=video/snapshot,t_1000,m_fast'" @click.stop="goPlay"></video>
						</template>
					</template>
					
					<div class="swiper-slide-dw" :class="activeIndex==index?' ':''"
						style="animation-duration: 1s;">
						<div class="swiper-slide-dw-Box">
							<div class="swiper-slide-dw-cen">
								<div v-for="(itema,indexa) in item.other.smallTitle" :key="indexa" :style="{
								height:itema.title?'':'20px',
								letterSpacing: '0.1em'
							}">
									{{itema.title}}
								</div>
							</div>
							<div class="swiper-slide-dw-name">
								<div v-for="(itema,indexa) in item.other.bigTitle" :key="indexa" >
									{{itema.title}}
								</div>
							</div>

							<div class="swiper-slide-dw-cenen">{{item.cenEn}}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="swiper-scrollbar"></div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {

		},
		props: {
			list: {
				typeof: Array,
				default: []
			}
		},
		data() {
			return {
				activeIndex: 0,
				lista: ''
			}
		},
		mounted() {
			let t = this;
			// {
			// 	delay: 5000,
			// 	disableOnInteraction: false,
			// }
			// t.$refs['video0'][0].play()
			const mySwiper = new this.$swiper('.swiper-index-banner', {
				// 方向
				direction: 'horizontal',
				// 自动播放
				autoplay: false,
				allowTouchMove: this.lista.length>1?true:false,
				scrollbar: {
					el: '.swiper-scrollbar',
					draggable: true,
				},
				on: {
					slideChangeTransitionStart(e) {
						t.activeIndex = this.activeIndex;
						t.$refs['video0'][t.activeIndex].play()
					},

				},
			});
			try{
				mySwiper.scrollbar.$dragEl.css('background', '#fff');
			}catch(e){
				//TODO handle the exception
			}
		},
		methods: {
			setList(e) {
				this.lista = e;
				this.$nextTick(function(){
					this.$refs['video0'][0].play()
				})
			},
			goJump(e) {
				console.log(e)
				let url = e.jump_url;
				if(!url){
					return
				}
				if (url.indexOf('http') != -1) {
					window.open(url, '_blank')
				} else {
					this.$router.push({
						path: "/newsDetail",
						name: 'newsDetail',
						query: {
							id: url
						}
					})
				}

			},
			goPlay(){
				let t=this;
				t.$refs['video' + t.activeIndex][0].play()
				t.$bus.$emit('overLoad')
			}
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.bannerContent{
		margin-bottom: 100px;
	}

	.swiper-index-banner {
		overflow: hidden;
		height: 800px;
		
	}

	.swiper-slide {
		position: relative;

		img {
			width: 100%;
			height: 800px;
			object-fit: cover;
		}

		video {
			width: 100%;
			height: 800px;
			object-fit: cover;
		}

		.swiper-slide-dw {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			z-index: 999;
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: end;
			flex-direction: column;
			padding-bottom: 86px;

			.swiper-slide-dw-Box {
				width: 1200px;
			}

			.swiper-slide-dw-name {
				font-size: 40px;
				
				font-weight: bold;
				color: #FFFFFF;
				// text-align: center;
				margin-top: 16px;
			}

			.swiper-slide-dw-cen {
				font-size: 1em;
				
				font-weight: bold;
				color: #FFFFFF;
				width: 900px;
				word-wrap: break-word;
				word-break: break-all;
			}

			.swiper-slide-dw-cenen {
				font-size: 35px;
				
				font-weight: 300;
				color: #FFFFFF;
				width: 900px;
				word-wrap: break-word;
				word-break: break-all;
				text-align: center;
			}
		}
	}

	.swiper-scrollbar {
		width: 320px;
		margin: 0 auto;
		left: 50%;
		transform: translateX(-50%);
	}
	@media screen and (max-width:1200px) {
		.swiper-slide-dw-Box {
			width: 100% !important;
			padding: 0 30px !important;
			box-sizing: border-box;
			
		}
		.swiper-slide-dw-cen{
			font-size: 14px !important;
			width: 100% !important;
		}
		.swiper-slide-dw-name{
			font-size: 18px !important;
		}
		.swiper-slide-dw-cenen {
			font-size: 14px !important;
		}
	}
</style>